import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import Slider from "./Slider";

export default function About() {
  const state = useSelector((state) => state);
  const [size, setSize] = useState("contain");
  const [position, setPosition] = useState("top");

  useEffect(() => {
    setInterval(() => {
      setSize("cover");
      setPosition("center");
    }, 500);
  }, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>
        <div
          className="abouthero"
          style={{
            backgroundSize: size,
            backgroundPosition: position,
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url(" +
              require("../img/bg1.jpg") +
              ")",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "40px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Facilities
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "100px" }}>
          <div
            style={{
              fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            BGS WORLD SCHOOL has established itself as a leader in academic
            excellence and holistic development over the past seven years. Known
            for its innovative approach, the school offers a cutting-edge
            curriculum that blends academic rigor with experiential learning,
            preparing students for the challenges of the 21st century.
            State-of-the-art facilities, including modern classrooms, science
            and computer labs, libraries, and sports complexes, provide a
            dynamic environment for learning and growth. The school emphasizes
            character building, diversity, and global awareness, fostering
            well-rounded individuals who excel academically and personally.
            Dedicated faculty, personalized guidance, and a focus on soft skills
            like leadership and teamwork ensure students are equipped for future
            success. Extracurricular activities, international collaborations,
            and wellness programs further enrich the student experience. BGS
            WORLD SCHOOL is committed to nurturing talent, inspiring lifelong
            learning, and empowering students to make a positive impact on the
            world. It is more than a school—it's a launchpad for future leaders.
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "50px" }}>
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (3).jpeg")}
                alt="Result Oriented Education"
                style={{
                  width: "100%",
                  minHeight: "50vh",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                100% Result Oriented
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  maxHeight: "50vh",
                }}
              >
                At BGS WORLD SCHOOL, we take pride in our consistent track
                record of academic excellence. Our result-oriented approach
                combines strategic teaching methodologies, regular assessments,
                and personalized attention to ensure every student achieves
                their full potential. Our dedicated faculty works tirelessly to
                identify and nurture each student's strengths while providing
                additional support in areas that need improvement. Through
                systematic planning, continuous monitoring, and effective
                feedback mechanisms, we maintain high academic standards and
                achieve remarkable results year after year. Our comprehensive
                assessment system includes regular diagnostic tests, formative
                evaluations, and detailed progress reports that help track
                student development. We also implement innovative teaching
                techniques, incorporating technology and practical applications
                to make learning more engaging and effective. Our success is
                reflected in our students' outstanding performance in board
                examinations, competitive tests, and various academic
                competitions. We provide specialized coaching sessions,
                doubt-clearing classes, and additional support materials to
                ensure thorough preparation.
              </div>
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid
            container
            spacing={4}
            alignItems="flex-start"
            direction={state.auth.isMobile ? "column-reverse" : "row"}
          >
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Montessori and Play-Based Energetic Kindergarten Classes
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our early childhood education program combines the proven
                Montessori method with engaging play-based learning activities.
                Our specially designed classrooms feature age-appropriate
                learning materials that encourage exploration, creativity, and
                independent thinking. Young learners develop essential skills
                through hands-on experiences, structured play, and guided
                discovery. The Montessori environment at BGS WORLD SCHOOL is
                carefully crafted to nurture each child's natural curiosity and
                love for learning. Our classrooms are equipped with premium
                Montessori materials, sensory tools, and interactive learning
                stations that promote cognitive development, fine motor skills,
                and social interaction. Each learning area is designed to
                support different aspects of child development, from practical
                life exercises to mathematical concepts. Our trained educators
                observe and document each child's progress, adjusting the
                learning environment and activities to match their developmental
                needs. We incorporate music, movement, art, and outdoor
                activities to provide a well-rounded early education experience.
                Regular parent-teacher interactions ensure that families are
                actively involved in their child's learning journey.
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (51).jpeg")}
                alt="Montessori Education"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  marginTop: state.auth.isMobile ? "300px" : "0px",
                }}
              />
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (56).jpeg")}
                alt="Vibrant Community"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  marginTop: state.auth.isMobile ? "-50px" : "0px",
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Vibrant Community of Educators
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our school boasts a dynamic team of passionate educators who
                bring diverse expertise and innovative teaching methods to the
                classroom. These experienced professionals regularly participate
                in professional development programs to stay current with the
                latest educational trends and technologies. Their collaborative
                approach ensures a rich learning environment where students
                benefit from varied teaching styles and perspectives. Our
                educators are not just teachers; they are mentors who inspire,
                guide, and nurture the next generation of leaders. In addition
                to their academic roles, our teachers are deeply committed to
                fostering a culture of curiosity, creativity, and critical
                thinking. They design engaging, student-centered lessons that
                encourage active participation and real-world problem-solving.
                Beyond the curriculum, they organize extracurricular activities,
                workshops, and community projects that help students develop
                essential life skills such as teamwork, leadership, and
                resilience.
              </div>
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid
            container
            spacing={4}
            alignItems="flex-start"
            direction={state.auth.isMobile ? "column-reverse" : "row"}
          >
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Best Educational Policies
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                BGS WORLD SCHOOL implements progressive educational policies
                that prioritize student welfare and academic excellence. Our
                policies are designed to create a balanced learning environment
                that promotes both academic achievement and personal growth. We
                maintain small class sizes to ensure personalized attention,
                allowing teachers to cater to the individual needs of each
                student. This approach fosters deeper understanding and stronger
                teacher-student relationships. Additionally, we implement modern
                assessment methods that go beyond traditional exams,
                incorporating project-based evaluations, peer reviews, and
                continuous feedback to measure holistic development. Our school
                also provides extensive extracurricular opportunities, including
                sports, arts, music, debate, and STEM clubs, to help students
                explore their passions and develop well-rounded skill sets.
                These activities are integral to our policy of nurturing
                creativity, teamwork, and leadership. We are committed to
                ensuring equal opportunities for all students, regardless of
                their background, by offering scholarships, mentorship programs,
                and inclusive learning resources.
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (63).jpeg")}
                alt="Educational Policies"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  marginTop: state.auth.isMobile ? "-50px" : "0px",
                }}
              />
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (14).jpeg")}
                alt="Life Skills"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  marginTop: state.auth.isMobile ? "-50px" : "0px",
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Infusing Righteous Way of Life Through Life Skills and Moral
                Education
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                We believe in nurturing not just academic excellence but also
                strong moral character, ensuring our students grow into
                well-rounded individuals. At BGS WORLD SCHOOL, we integrate
                values such as integrity, empathy, respect, and responsibility
                into our daily curriculum. Through character education programs,
                community service initiatives, and ethical discussions, we
                instill a sense of social responsibility and global citizenship
                in our students. Our holistic approach emphasizes the importance
                of emotional intelligence, self-discipline, and teamwork.
                Teachers and staff serve as role models, guiding students to
                make ethical decisions and develop a strong sense of purpose. We
                celebrate diversity and encourage students to embrace different
                perspectives, fostering an inclusive and harmonious environment.
                Beyond academics, we focus on life skills such as critical
                thinking, problem-solving, and effective communication,
                preparing students to face real-world challenges with
                confidence. By balancing intellectual growth with moral
                development, we aim to shape future leaders who are not only
                successful but also compassionate and principled, ready to
                contribute positively to society.
              </div>
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid
            container
            spacing={4}
            alignItems="flex-start"
            direction={state.auth.isMobile ? "column-reverse" : "row"}
          >
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Team of Expert Counsellors
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our dedicated team of expert counsellors provides comprehensive
                support to ensure the academic, emotional, and social well-being
                of every student. At BGS WORLD SCHOOL, we understand that each
                student has unique needs and challenges, which is why our
                counsellors offer personalized guidance and mentorship. They
                assist students in setting academic goals, exploring career
                options, and developing effective study habits, ensuring they
                stay on track for success. Beyond academics, our counsellors
                play a vital role in supporting students' mental health and
                emotional development. They provide a safe space for students to
                express their concerns, offering strategies to manage stress,
                build resilience, and foster positive relationships. Regular
                workshops on topics like time management, conflict resolution,
                and self-awareness further equip students with essential life
                skills. Our counsellors also collaborate closely with teachers
                and parents to create a supportive network around each student.
                By addressing challenges proactively and nurturing a growth
                mindset, they empower students to overcome obstacles and achieve
                their full potential. This holistic approach ensures that every
                student feels valued, confident, and prepared for the future.
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (9).jpeg")}
                alt="Counselling"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  marginTop: state.auth.isMobile ? "-50px" : "0px",
                }}
              />
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (20).jpeg")}
                alt="Inclusive Environment"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  marginTop: state.auth.isMobile ? "-50px" : "0px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Warm and Inclusive Environment
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                At BGS WORLD SCHOOL, we cultivate a warm and inclusive
                environment where every student feels valued, respected, and
                empowered to thrive. Our school community celebrates diversity,
                embracing students from all backgrounds, cultures, and
                abilities. We foster a culture of kindness, collaboration, and
                mutual respect, ensuring that everyone has a sense of belonging.
                Through inclusive policies and practices, we create
                opportunities for students to learn from one another and develop
                a global perspective. Our classrooms are designed to be safe
                spaces where students can express themselves freely, ask
                questions, and explore their unique talents. Teachers and staff
                are trained to recognize and address individual needs, ensuring
                that no student is left behind. We also organize events,
                workshops, and activities that promote inclusivity, such as
                cultural festivals, peer mentorship programs, and awareness
                campaigns. By nurturing empathy and understanding, we prepare
                students to become compassionate leaders who value diversity and
                contribute positively to society. At BGS WORLD SCHOOL,
                inclusivity is not just a value—it's a way of life.
              </div>
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout">
          <Grid
            container
            spacing={4}
            alignItems="flex-start"
            direction={state.auth.isMobile ? "column-reverse" : "row"}
          >
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Preparing Global Competitors
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our curriculum and programs are designed to prepare students for
                the challenges of the 21st century, equipping them with the
                knowledge, skills, and mindset needed to succeed in a rapidly
                changing world. At BGS WORLD SCHOOL, we offer a balanced blend
                of academic rigor and practical learning, ensuring students
                develop critical thinking, creativity, and problem-solving
                abilities. Our curriculum integrates STEM education, arts, and
                humanities, fostering well-rounded individuals who can adapt to
                diverse fields. We emphasize experiential learning through
                projects, internships, and collaborations with industry experts,
                giving students real-world exposure. Technology is seamlessly
                integrated into our programs, preparing students to navigate the
                digital age with confidence. Additionally, we focus on soft
                skills such as communication, teamwork, and leadership, which
                are essential for personal and professional growth. Our holistic
                approach also includes mindfulness and wellness programs,
                ensuring students maintain a healthy balance between academics
                and well-being. By combining innovation with tradition, we
                empower students to excel academically, think globally, and
                contribute meaningfully to society.
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (38).jpeg")}
                alt="Global Competitors"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  marginTop: state.auth.isMobile ? "-50px" : "0px",
                }}
              />
            </Grid>
          </Grid>
        </div>
        <br />
        <br /> <br />
        <br />
        <div className="aboutabout" style={{ marginBottom: "180px" }}>
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={5}>
              <img
                src={require("../img/bgsimg (37).jpeg")}
                alt="Trust and Growth"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <div
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  color: themeStyle.primaryColor,
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                Years of Trust and Growth in the Community
              </div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "2.1vmin",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Over the past seven years, BGS WORLD SCHOOL has built a strong
                reputation for academic excellence, innovation, and holistic
                development. Our commitment to providing a world-class education
                has resulted in consistently outstanding academic achievements
                and a track record of students excelling in competitive exams
                and extracurricular activities. We take pride in our
                state-of-the-art facilities, which include modern classrooms,
                science and computer labs, libraries, and sports complexes, all
                designed to support a dynamic learning experience. Our dedicated
                faculty, cutting-edge curriculum, and emphasis on character
                building have shaped countless students into confident,
                compassionate, and capable individuals. We have also fostered a
                vibrant school community that celebrates diversity, creativity,
                and collaboration. Through partnerships with global institutions
                and participation in international events, we provide students
                with opportunities to broaden their horizons and develop a
                global perspective. As we continue to grow, our mission remains
                unchanged: to inspire lifelong learning, nurture talent, and
                empower students to make a positive impact on the world. BGS
                WORLD SCHOOL is not just a school—it's a launchpad for future
                leaders.
              </div>
            </Grid>
          </Grid>
        </div>
        <Benchmark />
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
